import moment from 'moment'

// 时间过滤器
export const dateForMet = function (val, data = 'YYYY-MM-DD HH:mm:ss') {
  if (val == '0' || val == '') {
    return '-'
  }
  const time = moment(val * 1000).format(data);
  return time;
}